import React from "react";
import MethodsPay from "../../components/Plans/MethodsPay";
export default function CheckOutPlan(params) {
    return(
        <div className="bg-blue-light p-40">
            <MethodsPay/>
        </div>
    )
}